import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import { BsChatText } from "react-icons/bs";
import TranscriptionTimelineItem from "./TranscriptionTimelineItem";
import useTitanApp from "../../../../../../../hooks/useTitanApp";

const parseTranscriptString = (text) => {
  if (!text) return [];

  return text.split(" | ").map((chunk) => {
    const parts = chunk.split("-");

    return {
      personIs: parts[0]?.trim(),
      timeSpokenAt: parts[1]?.trim(),
      speech: parts.slice(2).join("-").trim(),
    };
  });
};

const mergeChunks = (data) => {
  const merged = [];

  data.forEach((item) => {
    const last = merged[merged.length - 1];

    if (
      last &&
      last.personIs === item.personIs &&
      last.timeSpokenAt === item.timeSpokenAt
    ) {
      last.speech += " " + item.speech;
    } else {
      merged.push({ ...item });
    }
  });

  return merged;
};

export default function TranscriptionTimeline() {
  const { auth, templateState, patientState, appState } = useTitanApp();

  const { user } = auth || {};
  const { fullTranscript, consultationInitiatedOn, transcriptionState } =
    templateState || {};
  const {
    selectedPatientConsultation,
    transcript: liveTranscript,
    isSummaryGenerated,
    isSummaryStreaming,
  } = patientState || {};
  const { darkMode } = appState || {};

  const summaryReady = isSummaryGenerated && !isSummaryStreaming;
  const transcriptionText =
    selectedPatientConsultation?.transcription ||
    (summaryReady ? liveTranscript : null);

  const isLiveFormat = transcriptionText?.includes(" | ");

  const parsedTranscript =
    transcriptionText && isLiveFormat
      ? mergeChunks(parseTranscriptString(transcriptionText))
      : [];

  return (
    <>
      {fullTranscript && fullTranscript.length > 0 ? (
        <Timeline className="pc-timeline-wrapper">
          <TimelineItem>
            <TimelineSeparator>
              <BsChatText className="icons-color" />
              <TimelineConnector />
            </TimelineSeparator>

            <TimelineContent className="pc-timeline-content">
              <p className="initiated-text">
                <span>{user?.name}</span> initiated a <strong>walk in</strong>{" "}
                consultation on{" "}
                {consultationInitiatedOn?.toLocaleDateString("en-GB")}
              </p>

              {fullTranscript.map((transcript, idx) => (
                <TranscriptionTimelineItem
                  key={idx}
                  transcript={transcript}
                  darkMode={darkMode}
                />
              ))}
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      ) : transcriptionText && !isLiveFormat ? (
        <p className="mt-4 text-sm">{transcriptionText}</p>
      ) : transcriptionText && isLiveFormat ? (
        <Timeline className="pc-timeline-wrapper">
          <TimelineItem>
            <TimelineSeparator>
              <BsChatText className="icons-color" />
              <TimelineConnector />
            </TimelineSeparator>

            <TimelineContent className="pc-timeline-content">
              <p className="initiated-text">
                <span>{user?.name}</span> initiated a <strong>walk in</strong>{" "}
                consultation on{" "}
                {consultationInitiatedOn?.toLocaleDateString("en-GB")}
              </p>

              {parsedTranscript.map((item, idx) => (
                <TranscriptionTimelineItem
                  key={idx}
                  transcript={item}
                  darkMode={darkMode}
                />
              ))}
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      ) : (
        <div className={`text-center py-12 text-gray-300`}>
          <p className="text-sm">
            {transcriptionState === "idle"
              ? "Start a consultation to see the live transcript"
              : "Listening..."}
          </p>
          <p className="mt-2 text-xs">
            Live transcription will appear here during consultations
          </p>
        </div>
      )}
    </>
  );
}
